// extracted by mini-css-extract-plugin
export default {"file-preview":"FilePreview_file-preview__fG8Vx","svg":"FilePreview_svg__6esTB","file-view":"FilePreview_file-view__Cq8z1","backdrop":"FilePreview_backdrop__-rdb5"};